import React from 'react';
import { HealthCheckGroup } from 'services/health';
import HealthMatrixTable from './HealthMatrixTable';
import HealthCheckStatus from './HealthCheckStatus';
import { GroupContainer, GroupTitle, IconGrid } from '../styles';
import { HealthCheckState } from 'types/health';

interface Props {
  group: HealthCheckGroup;
  states: Record<string, HealthCheckState>;
  onRetry: (checkId: string) => void;
}

const HealthGroup: React.FC<Props> = ({ group, states, onRetry }) => {
  if ((group.layout ?? 'matrix') === 'matrix') {
    const rowLabel = group.config?.rowLabel ?? group.title;
    return (
      <GroupContainer>
        <GroupTitle>{group.title}</GroupTitle>
        <HealthMatrixTable checks={group.checks} states={states} onRetry={onRetry} rowLabel={rowLabel} />
      </GroupContainer>
    );
  }

  return (
    <GroupContainer>
      <GroupTitle>{group.title}</GroupTitle>
      <IconGrid>
        {group.checks.map((check) => (
          <HealthCheckStatus
            key={check.id}
            check={check}
            state={states[check.id]}
            onRetry={onRetry}
            mode="icon"
            title={check.label}
          />
        ))}
      </IconGrid>
    </GroupContainer>
  );
};

export default HealthGroup;
